import { api } from '@xtnd/web/shared/api';
import type {
  TrustRequestTransactionsResponse,
  TrustRequestTransactionQueryParams,
} from '../types/trustRequestTransactionTypes';

export const trustRequestTransactionApi = {
  // Get trust request transactions with filtering
  getTrustRequestTransactions: async (params: TrustRequestTransactionQueryParams): Promise<TrustRequestTransactionsResponse> => {
    const queryParams = new URLSearchParams();
    
    if (params.dateFrom) {
      queryParams.set('dateFrom', params.dateFrom);
    }
    if (params.dateTo) {
      queryParams.set('dateTo', params.dateTo);
    }
    if (params.matterId) {
      queryParams.set('matterId', params.matterId);
    }
    if (params.clientIds && params.clientIds.length > 0) {
      params.clientIds.forEach(id => queryParams.append('clientIds', id));
    }
    if (params.trustRequestState && params.trustRequestState.length > 0) {
      params.trustRequestState.forEach(state => queryParams.append('trustRequestState', state));
    }
    if (params.createdBy) {
      queryParams.set('createdBy', params.createdBy);
    }
    if (params.status && params.status.length > 0) {
      params.status.forEach(s => queryParams.append('status', s));
    }
    if (params.page) {
      queryParams.set('page', String(params.page));
    }
    if (params.limit) {
      queryParams.set('limit', String(params.limit));
    }
    if (params.sortBy) {
      queryParams.set('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
      queryParams.set('sortOrder', params.sortOrder);
    }
    if (params.cursor) {
      queryParams.set('cursor', params.cursor);
    }
    
    const queryString = queryParams.toString();
    return api.get<TrustRequestTransactionsResponse>(`/juniper-trr-transactions${queryString ? `?${queryString}` : ''}`);
  },

  bulkRelease: async (payload: { juniperTRRIds: string[]; requestId: string; reason?: string; emailTemplateOverrideId?: string }) => {
    return api.post('/juniper-trr-transactions/bulk-release', payload);
  },

  bulkSendFollowUp: async (payload: { juniperTRRIds: string[]; requestId: string; reason?: string; emailTemplateOverrideId?: string }) => {
    return api.post('/juniper-trr-transactions/bulk-send-follow-up', payload);
  },

  bulkRegeneratePdf: async (payload: { juniperTRRIds: string[]; requestId: string; reason?: string }) => {
    return api.post('/juniper-trr-transactions/bulk-regenerate-pdf', payload);
  },

  bulkRefresh: async (payload: { juniperTRRIds: string[]; requestId: string; reason?: string }) => {
    return api.post('/juniper-trr-transactions/bulk-refresh', payload);
  },

  bulkSimulate: async (payload: { juniperTRRIds: string[]; requestId: string; reason?: string; eventType: 'update' | 'delete' }) => {
    return api.post('/juniper-trr-transactions/bulk-simulate', payload);
  },

  bulkMarkCompleted: async (payload: { juniperTRRIds: string[]; requestId: string; reason?: string }) => {
    return api.post('/juniper-trr-transactions/bulk-mark-completed', payload);
  },
};



